import React from 'react';
import { Row, Col, Alert } from 'react-bootstrap';

const EnergyStats = ({ production, consumption }) => {
  const maxEnergy = 30000;
  
  return (
    <Row className="my-5">
      <Col md={6} className="mb-4">
        <div className="energy-card p-4 shadow-sm rounded">
          <h5 className="mb-3">PRODUCTION JOURNALIER MAXIMUM</h5>
          <div className="d-flex justify-content-between mb-2">
            <span>0 Wh</span>
            <span className="fw-bold text-success">{production.toLocaleString()} Wh</span>
            <span>30,000 Wh</span>
          </div>
          <div className="progress" style={{ height: '25px' }}>
            <div 
              className="progress-bar bg-success" 
              role="progressbar" 
              style={{ width: `${(production / maxEnergy) * 100}%` }}
              aria-valuenow={production} 
              aria-valuemin="0" 
              aria-valuemax={maxEnergy}
            >
              <span className="position-absolute" style={{ right: '10px', color: '#000' }}>
                {((production / maxEnergy) * 100).toFixed(0)}%
              </span>
            </div>
          </div>
          <div className="mt-2 small text-muted">
            Capacité de production de votre pack solaire
          </div>
        </div>
      </Col>
      
      <Col md={6} className="mb-4">
        <div className="energy-card p-4 shadow-sm rounded">
          <h5 className="mb-3">VOTRE CONSOMMATION (Wh/j)</h5>
          <div className="d-flex justify-content-between mb-2">
            <span>0 Wh</span>
            <span className="fw-bold text-danger">{consumption.toLocaleString()} Wh</span>
            <span>30,000 Wh</span>
          </div>
          <div className="progress" style={{ height: '25px' }}>
            <div 
              className="progress-bar bg-danger" 
              role="progressbar" 
              style={{ width: `${(consumption / maxEnergy) * 100}%` }}
              aria-valuenow={consumption} 
              aria-valuemin="0" 
              aria-valuemax={maxEnergy}
            >
              <span className="position-absolute" style={{ right: '10px', color: '#000' }}>
                {((consumption / maxEnergy) * 100).toFixed(0)}%
              </span>
            </div>
          </div>
          <div className="mt-2 small text-muted">
            Estimation basée sur vos équipements sélectionnés
          </div>
          {consumption > production && (
            <Alert variant="warning" className="mt-3 mb-0">
              <strong>Attention!</strong> Votre consommation ({consumption.toLocaleString()} Wh) dépasse votre production ({production.toLocaleString()} Wh). 
              Veuillez envisager un pack plus puissant ou réduire votre consommation.
            </Alert>
          )}
        </div>
      </Col>
    </Row>
  );
};

export default EnergyStats;